import { render, staticRenderFns } from "./CollectiveAgreements.vue?vue&type=template&id=1123c4a9&scoped=true&"
import script from "./CollectiveAgreements.vue?vue&type=script&lang=js&"
export * from "./CollectiveAgreements.vue?vue&type=script&lang=js&"
import style0 from "./CollectiveAgreements.vue?vue&type=style&index=0&id=1123c4a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1123c4a9",
  null
  
)

export default component.exports